const INSTANT_MS = 200;

let instantUntil = 0;

export const skipFeedMotion = () => {
  instantUntil = performance.now() + INSTANT_MS;
};

export const feedMotionSkipped = () => performance.now() < instantUntil;
